import React from 'react';

import { FieldProps } from 'formik';
import { StyleSheet } from 'react-native';

import { TextInput } from 'components/ucl/text-input';
import { TextInputProps } from 'components/ucl/text-input/types';
import { Box } from 'components/ui';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { spacing } from 'styles/constants';

export const FormikTextInput = React.forwardRef<
  HTMLInputElement,
  FieldProps<string, { [key: string]: string }> & TextInputProps
>(({ field, form, ...props }, ref) => {
  const { errors, touched } = form;

  const fieldTouched = touched?.[field.name];
  const errorMessage = errors?.[field.name];
  const { onBlur, onChange } = field;

  const errorMessageDisplay = fieldTouched && errorMessage ? errorMessage : undefined;

  useLogUserErrorMessage({
    message: errorMessageDisplay,
    severity: LogUserErrorSeverity.Unknown,
    context: {
      fieldName: field?.name,
      label: props?.label,
    },
  });

  return (
    <Box style={styles.container}>
      <TextInput
        errorMessage={errorMessageDisplay}
        {...props}
        wrapperRef={ref}
        onChangeText={onChange(field.name)}
        onBlur={onBlur(field.name)}
      />
    </Box>
  );
});

const styles = StyleSheet.create({
  container: {
    margin: spacing.$2,
  },
});
